import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {THEME_CONFIG} from '../../../../environments/tokens/theme.token';
import {CdkScrollable} from '@angular/cdk/scrolling';
import {MatButton} from '@angular/material/button';
import {DecimalPipe} from '@angular/common';

@Component({
  selector: 'app-order-offer-dialog',
  templateUrl: './order-offer-dialog.component.html',
  styleUrl: './order-offer-dialog.component.scss',
  imports: [CdkScrollable, MatDialogContent, MatButton, DecimalPipe],
  standalone: true
})
export class OrderOfferDialogComponent {
  protected readonly themeConfig = inject(THEME_CONFIG)

  readonly data = inject<{
    promotion: any;
    rule: any;
    promoEligibleTotal: number;
  }>(MAT_DIALOG_DATA);
  sortedCategories: any[] = [];
  private dialogRef = inject(MatDialogRef<OrderOfferDialogComponent>);

  constructor() {
    this.sortedCategories = (this.data.rule.categories || [])
      .sort((a: any, b: any) => (a.sortOrder || 0) - (b.sortOrder || 0));
  }

  ngOnInit(): void {
    this.sortedCategories = (this.data.rule.categories || [])
      .sort((a: any, b: any) => (a.sortOrder || 0) - (b.sortOrder || 0));
  }

  ignore(): void {
    this.dialogRef.close({action: 'ignore'});
  }

  customize(): void {
    this.dialogRef.close({action: 'customize'});
  }
}
